import { Link } from 'react-router';
import { MessageSquare } from 'lucide-react';
import type { RequestListItem } from '@product-portal/shared';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { formatRelative } from '@/lib/format';
import { NO_PRODUCT_LABEL } from '@/lib/labels';
import { cn } from '@/lib/utils';
import { RequestStatusPill } from './status-pill';

/**
 * « Mes demandes » table of screen 01. A row is highlighted while
 * « En attente de réponse » is on — an indicator computed by the API, never a status.
 */
export function RequestsTable({ items, showRequester = false }: { items: RequestListItem[]; showRequester?: boolean }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Réf.</TableHead>
          <TableHead>Demande</TableHead>
          {showRequester && <TableHead>Demandeur</TableHead>}
          <TableHead>Produit</TableHead>
          <TableHead>Statut</TableHead>
          <TableHead>Mise à jour</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((item) => (
          <TableRow key={item.id} className={cn(item.awaitingReply && 'bg-warning')}>
            <TableCell className="text-muted-foreground tabular-nums">{item.reference}</TableCell>
            <TableCell>
              <Link to={`/demandes/${item.id}`} className="font-bold text-foreground no-underline hover:text-foreground">
                {item.title}
              </Link>
              {item.awaitingReply && (
                <span className="mt-1 flex items-center gap-1.5 text-xs font-bold text-warning-foreground">
                  <MessageSquare aria-hidden="true" className="size-3.5" strokeWidth={2.2} />
                  En attente de votre réponse
                </span>
              )}
            </TableCell>
            {showRequester && (
              <TableCell className="text-foreground-secondary">
                {item.requester.firstName} {item.requester.lastName}
              </TableCell>
            )}
            <TableCell className="text-foreground-secondary">
              {item.product?.name ?? NO_PRODUCT_LABEL}
            </TableCell>
            <TableCell>
              <RequestStatusPill status={item.status} />
            </TableCell>
            <TableCell className="text-muted-foreground">{formatRelative(item.lastActivityAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
